const ITEMS = [
  "Automotive Photography",
  "Vehicle Rollers",
  "Banquet Cinematics",
  "Business Intro Videos",
  "Greater Toronto Area",
  "High-Value Cinema",
];

export default function Marquee() {
  return (
    <div className="relative border-y border-white/10 bg-surface/60 py-5 overflow-hidden" data-testid="marquee-band">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="font-bebas text-2xl md:text-3xl tracking-[0.12em] text-zinc-200 px-6">
                  {item}
                </span>
                <span className="text-gold text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
